// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".flex-spacer_4b3f {\n  flex: 1 1 auto;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/FlexSpacer.scss","FlexSpacer.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;ACCJ","file":"FlexSpacer.scss","sourcesContent":[".flex-spacer {\n    flex: 1 1 auto;\n}\n",".flex-spacer {\n  flex: 1 1 auto;\n}"]}]);
// Exports
exports.locals = {
	"flex-spacer": "flex-spacer_4b3f"
};
module.exports = exports;
